import { STATUS } from "@/constant/statusConstants";

const getBackgrounInitialValues = (showData = null) => {
  const data = showData?.data;
  return {
    name: data?.name || "",
    page: data?.page || "",
    sport_type: data?.sport_type || "",
    sport_id: data?.sport_id || "",
    language_id: data?.language_id || "",
    image_preview: data?.image_preview || "",
    status: data?.status || STATUS.INACTIVE,
  };
};

export default getBackgrounInitialValues;
